import logger from "@app/utils/logger";

export const hideZendeskWidget = () => {
  try {
    if (window.zE) {
      window.zE("webWidget", "hide");
    }
  } catch (error: any) {
    logger.debug("Failed to hide Zendesk widget", error);
  }
};

export const openZendeskWidget = () => {
  try {
    if (window.zE) {
      window.zE("webWidget", "show");
      window.zE("webWidget", "open");
    }
  } catch (error: any) {
    logger.debug(`Failed to open Zendesk widget`);
  }
};
